import { render, staticRenderFns } from "./StatistictTypeTourism.vue?vue&type=template&id=41d84658&scoped=true&"
import script from "./StatistictTypeTourism.vue?vue&type=script&lang=js&"
export * from "./StatistictTypeTourism.vue?vue&type=script&lang=js&"
import style0 from "./StatistictTypeTourism.vue?vue&type=style&index=0&id=41d84658&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d84658",
  null
  
)

export default component.exports